<script setup lang="ts">
import {
  iKeyIcon,
  iKeyIconSize,
  iKeyIconShape,
  iKeyIconStyle,
  iKeyIconType,
} from '@inscribe/signal';

interface Props {
  title?: string;
  icon?: string;
}

withDefaults(defineProps<Props>(), {
  title: 'No filters added yet',
  icon: 'medium-setting-slider-horizontal',
});
</script>

<template>
  <div
    class="filters-empty-state d-flex flex-column align-items-center i-radius-5xl i-p-11 i-gap-6"
  >
    <i-key-icon
      :icon="icon"
      :size="iKeyIconSize.MD"
      :type="iKeyIconType.NEUTRAL"
      :icon-style="iKeyIconStyle.OUTLINE"
      :shape="iKeyIconShape.SQUARE"
    />
    <div class="title i-text-button-2">{{ title }}</div>

    <!-- Accept button content via slot -->
    <slot name="action" />
  </div>
</template>

<style scoped lang="scss">
.filters-empty-state {
  background: var(--surface-neutral-subtle);

  .title {
    color: var(--text-neutral-bold);
  }
}
</style>
